import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';

// Beimportáljuk a textúrát ide is!
// @ts-ignore
import textureBg from '../videos/texture.png'; 

const Welcome: React.FC = () => {
  return (
    <Box 
      sx={{ 
        backgroundColor: 'primary.main', 
        
        // VISSZAÁLLÍTVA ITT IS: Csempézés
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
        
        backgroundBlendMode: 'multiply', 
        py: { xs: 10, md: 15 }, 
        textAlign: 'center' 
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          {/* A variant="h2" automatikusan az AMORESA betűtípust kapja az App.tsx-ből */}
          <Typography 
            variant="h2" 
            sx={{ 
              color: '#ffffff', 
              fontSize: { xs: '3rem', md: '5rem' }
            }}
          >
            Kedves Családunk és Barátaink!
          </Typography>
          
          {/* A variant="h5" automatikusan a Blosta betűtípust kapja az App.tsx-ből */}
          <Typography 
            variant="h5" 
            sx={{ 
              color: 'text.secondary', 
              lineHeight: 1.8, 
              fontWeight: 300,
              mt: 2,
              fontSize: { xs: '1.2rem', md: '1.5rem' }
            }}
          >
            Szeretettel meghívunk Benneteket <strong style={{ color: '#ffffff' }}>2026. augusztus 21-én</strong> tartandó 
            esküvőnkre és az azt követő ünneplésre.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Welcome;